import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { NavBar } from './components/NavBar';
import { HeroSection } from './components/HeroSection';
import { TrustStrip } from './components/TrustStrip';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { OfferStack } from './components/OfferStack';
import { FAQSection } from './components/FAQSection';
import { GuaranteeBlock } from './components/GuaranteeBlock';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ReviewsSection } from './components/ReviewsSection';
import { OfferBanner } from './components/OfferBanner';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '1997464671652194');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-deep font-sans text-body selection:bg-amber/30 selection:text-white" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <NavBar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <TrustStrip data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <SolutionSection data-id="element-7" />
        <ReviewsSection data-id="element-8" />
        <OfferBanner data-id="element-9" />
        <OfferStack data-id="element-10" />
        <FAQSection data-id="element-11" />
        <GuaranteeBlock data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <SocialProofPopup data-id="element-14" />
    </div>;
}